import WithSidebar from 'Layout/WithSidebar';
import { productPageTitles } from 'components/NavigationSideBar/mockData';
import GeneralInfoBox from 'components/GeneralInfoBox';
import NavigationSideBar from 'components/NavigationSideBar';
import Banner from 'components/Banner';
import legalInfoBanner from 'images/legal-info-banner.jpg';
import { aboutProductFiles } from 'components/PDFBox/mockData';
import PDFBox from 'components/PDFBox';
import { data } from './mockData';

const TermsAndConditions = () => {
    return (
        <div className="container">
            <Banner title="Terms & Conditions" image={legalInfoBanner} buttonText="Read more" />
            <div className="inner-container with-top-offset">
                {/* TODO: ADD CORRECT INFO TO SIDEBAR */}
                <WithSidebar Sidebar={<NavigationSideBar items={productPageTitles} offset={880} />}>
                    <PDFBox title="Privacy policy" data={[aboutProductFiles[0]]} />
                    {data.map(item => (
                        <GeneralInfoBox key={item.title}>
                            <h3>{item.title}</h3>
                            {item.blocks.map((p, index) => (
                                <p key={index}>{p}</p>
                            ))}
                        </GeneralInfoBox>
                    ))}
                </WithSidebar>
            </div>
        </div>
    );
};

export default TermsAndConditions;
